import { createMessage, SB } from '@play-co/replicant';
import createMessages from '../config/messages/createMessages';
import { incrementVisitedCount } from './visit.modifiers';
import * as Fate from '../fate';

export const visitMessages = createMessages({
  /**
   * Record visit from friend
   */
  trackVisit: createMessage(
    SB.object({ name: SB.string() }),

    (state, { name }, { senderId, timestamp }) => {
      Fate.modifiers.resolveStatusEffect(state, 'hadVisitor', true, timestamp);

      incrementVisitedCount(state, {
        name,
        friendId: senderId,
        now: timestamp,
      });
    },
  ),

  /**
   * Kick out visitor due to visited player coming online
   */
  kickVisitor: createMessage(SB.object({}), (state, _, { senderId }) => {
    if (state.visit.visitSession?.friendId === senderId) {
      state.visit.visitSession.isKickedOut = true;
    }
  }),

  /** @deprecated TODO: remove in a future release */
  deleteVisitSession: createMessage(SB.object({}), (state) => {
    delete state.visit.visitSession;
  }),

  /**
   * Revive pet.
   */
  revivePet: createMessage(
    SB.object({
      friendName: SB.string(),
    }),
    (state, { friendName }) => {
      state.visit.revivedBy = friendName;
    },
  ),
});
